import type { AnalyticsKpi } from '../../demo/types'
import { Card, GlossaryText, Icon } from '../../ui'
import type { IconName } from '../../ui/Icon'
import styles from './KpiRow.module.css'

const icons: Record<string, IconName> = {
  spend: 'dollar',
  orders: 'clipboard',
  revenue: 'trend',
  roas: 'target',
  reach: 'users',
  impressions: 'eye',
  cpm: 'dollar',
}

function formatValue(kpi: AnalyticsKpi): string {
  if (kpi.format === 'currency') return `$${kpi.value.toLocaleString('en-US', { maximumFractionDigits: 0 })}`
  if (kpi.format === 'currency2') return `$${kpi.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  if (kpi.format === 'multiple') return `${kpi.value.toFixed(1)}×`
  return kpi.value.toLocaleString('en-US', { maximumFractionDigits: 0 })
}

function formatDelta(value: number): string {
  const sign = value >= 0 ? '+' : '−'
  return `${sign}${Math.abs(value * 100).toFixed(0)}%`
}

interface KpiRowProps {
  kpis: AnalyticsKpi[]
  compare: boolean
}

export function KpiRow({ kpis, compare }: KpiRowProps) {
  return (
    <div className={styles.row} data-scope="analytics-kpi-row">
      {kpis.map((kpi) => (
        <Card className={styles.card} key={kpi.key}>
          <span className={styles.icon}><Icon name={icons[kpi.key] ?? 'trend'} size={22} /></span>
          <div>
            <p className={styles.label}><GlossaryText text={kpi.label} paren={kpi.key === 'cpm' || kpi.key === 'roas'} /></p>
            <p className={styles.value}>{formatValue(kpi)}</p>
            {compare ? (
              <p className={styles.delta}>
                较上一周期 <span className={kpi.deltaPrev >= 0 ? styles.up : styles.down}>{formatDelta(kpi.deltaPrev)}</span>
              </p>
            ) : null}
          </div>
        </Card>
      ))}
    </div>
  )
}
